import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';

import { messages } from './messages';
import { getShipFromContacts } from '../../../carrier-pickup/carrier-pickup-api';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import { useShipFrom } from '../../../hooks/ship-froms/use-ship-from';
import { useFulfillmentPlannerContext } from '../../context';

import { PickupInformation } from './index';

const NOTIFICATION_CONTACTS_ERROR = {
  notificationType: NOTIFICATION_TYPE_ERROR,
  title: <FormattedMessage {...messages.failedShipFromContactsTitle} />,
  content: <FormattedMessage {...messages.failedShipFromContactsContent} />,
};

/**
 * @param {object} props
 * @param {string} props.className
 * @returns {JSX.Element}
 */
export const PickupInformationByFulfillmentPlanId = ({ className }) => {
  const [selectedContact, setSelectedContact] = useAsyncSafeState(null);
  const { shipFromId } = useFulfillmentPlannerContext();
  const { pickupSettings, name } = useShipFrom(shipFromId) || emptyObject;
  const sellerSelectedPickupDays = pickupSettings?.days || emptyArray;
  const hasSellerSelectedPickupDays = sellerSelectedPickupDays.length > 0;
  const { startTime, endTime, shipFromContactId, instructions } = sellerSelectedPickupDays[0] || emptyObject;

  useEffect(() => {
    if (!shipFromId) {
      return;
    }

    getShipFromContacts(shipFromId)
      .then(({ data = [] }) => {
        if (shipFromContactId) {
          setSelectedContact(data.find((contact) => contact.shipFromContactId === shipFromContactId));
        } else {
          setSelectedContact(null);
        }
      })
      .catch(() => {
        NotificationService.showNotification(NOTIFICATION_CONTACTS_ERROR);
      });
  }, [setSelectedContact, shipFromContactId, shipFromId]);

  return (
    <PickupInformation
      className={className}
      endTime={endTime}
      hasSellerSelectedPickupDays={hasSellerSelectedPickupDays}
      instructions={instructions}
      selectedContact={selectedContact}
      shipFromId={shipFromId}
      shipFromName={name}
      startTime={startTime}
    />
  );
};
